<div class="flex flex-1 min-h-0 flex-col h-full">
  @let selectedTab = selectedTab$ | async;

  @if (selectedTab) {
    <div class="flex flex-none flex-row justify-between items-start w-full">
      <h2>{{ user | userDisplay }}</h2>
      @if (!user.is_active) {
        <span class="bg-gray-500 rounded-[0.25rem] py-1 px-2 text-xs text-white font-bold"> Inactive </span>
      }
      @if (isSubmitting) {
        <app-spinner size="sm" />
      }
    </div>

    <nav class="flex-none" mat-tab-nav-bar [tabPanel]="tabPanel">
      @for (tab of tabs; track tab) {
        <a
          mat-tab-link
          data-test-id="edit-user-tab-select"
          class="basis-full"
          [active]="selectedTab === tab"
          (click)="navigateTab(tab)"
        >
          {{ tab | titlecase }}
        </a>
      }
    </nav>
    <mat-tab-nav-panel #tabPanel class="flex flex-1 min-h-0 flex-col">
      <div class="flex flex-1 min-h-0 flex-col">
        @switch (selectedTab) {
          @case ('details') {
            <app-user-form
              class="flex flex-1 min-h-0 flex-col mt-4"
              [user]="user"
              [clients]="clients"
              (isSubmittingSignal)="handleIsSubmitting($event)"
              (updateUserSignal)="updateUser()"
            />
          }
          @case ('roles') {
            <app-manage-user-roles
              class="flex flex-1 min-h-0 flex-col mt-4"
              [userId]="user.user_id"
              (isSubmittingSignal)="handleIsSubmitting($event)"
            />
          }
        }
      </div>
    </mat-tab-nav-panel>
  } @else {
    <div class="flex flex-col flex-1 justify-center content-center items-center">
      <app-spinner size="lg" />
    </div>
  }
</div>
